<ng-container *transloco="let t">
  <form nz-form [formGroup]="form" class="flex flex-col gap-y-2">
    <div formArrayName="filters" class="flex flex-col gap-y-2">
      @for (
        filter of filtersArray.controls;
        let i = $index;
        track filter.value.id
      ) {
        <div class="flex flex-row gap-x-1">
          <div
            [formGroupName]="i"
            class="grid grid-cols-12 w-full gap-x-2"
          >
            <form-control
              class="col-span-4"
              [control]="getFieldControl(filter)"
              [label]="t('FILTERS.FORM.SELECT')"
              [type]="'select'"
              [value]="null"
              [typeInputs]="{ options: filters() }"
              (controlChanges)="onChangeFilterField($event, i)"
            />

            @if (filter.value.field) {
              @if (filter.value.condition) {
                @if (filter.value.type === 'selectGroup') {
                  <form-control
                    class="col-span-8"
                    [control]="getValueControl(filter)"
                    [type]="'selectGroup'"
                    [placeholder]="t('FILTERS.FORM.SELECT')"
                    [typeInputs]="{options: getTypesFilterOperators(filter.value.field)[0]?.options || []}"
                  />

                } @else {
                  <form-control
                    class="col-span-4"
                    [control]="getConditionControl(filter)"
                    [type]="'select'"
                    [placeholder]="t('FILTERS.FORM.OPERATOR')"
                    [typeInputs]="{
                      options: numberFilterOperators(),
                    }"
                  />
                }

              }
              @if (filter.value.type !== 'selectGroup') {
                <form-control
                  [class]="{
                    'col-span-4': filter.value.condition,
                    'col-span-8': !filter.value.condition,
                  }"
                  [control]="getValueControl(filter)"
                  [label]="filter.value.label"
                  [type]="filter.value.type"
                  [typeInputs]="getFilterTypeInputs(filter.value.field)"
                />
              }
            }
          </div>

          <div class="flex items-center justify-end">
            <ui-button icon="close" buttonType="text" (click)="removeItem(i)" />
          </div>
        </div>
      }
    </div>

    @if (filtersArray.controls.length <= 0) {
      <div class="flex gap-x-1.5 mx-4 text-gray-400">
        <ui-icon icon="info-circle" />
        {{ t('FILTERS.FORM.NO_RESULTS') }}
      </div>
    }

    <div class="border-t border-dashed border-gray-300 my-0.5"></div>
    <div class="flex flex-row justify-between">
      <ui-button icon="plus-circle" buttonType="link" (click)="addFilter()">
        {{ t('FILTERS.FORM.ADD') }}
      </ui-button>
      <div class="flex gap-x-3">
        <ui-button buttonType="text" (click)="removeFilters()">
          {{ t('FILTERS.FORM.REMOVE') }}
        </ui-button>
        <ui-button buttonType="primary" (click)="applyFilters()">
          {{ t('FILTERS.FORM.APPLY') }}
        </ui-button>
      </div>
    </div>
  </form>
</ng-container>
